export default "__VITE_ASSET__$BHjnmSU__"